import { useCallback, useEffect } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { setGroupList } from 'v3/data/store/group/actions';
import { IGroupsList } from 'v3/data/store/group/types';
import { getGroupList } from 'v3/services/api';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';
import { SubtitleMediumBoldStyled, SubtitleMediumStyled } from 'v3/shared/typography/SubtitleMedium/styles';
import { AlignedValue, BoxCustom, Container, Content } from './styles';

interface GroupsTableProps {
  listItem?: IGroupsList;
}

export const SellerRankListMobile: React.FC<GroupsTableProps> = ({ listItem }) => {
  const { filter, list } = useStoreSelector((store) => store.rankSeller);
  const { page, rowsPerPage } = filter;
  const { items } = list;

  const fetchRankList = useCallback(async () => {
    try {
      const response = await getGroupList(filter);
      setGroupList(response.data);
    } catch (error) {
      showErrorDialog('Erro ao obter lista', error);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchRankList();
  }, [fetchRankList]);

  if (!Array.isArray(items) || items.length === 0) {
    return <NoItemsFound />;
  }

  return (
    <BoxCustom>
      {list.items.map((store) => (
        <Container key={store.id}>
          <Content>
            <AlignedValue>
              <SubtitleMediumBoldStyled>Grupo</SubtitleMediumBoldStyled>
            </AlignedValue>

            <AlignedValue>
              <SubtitleMediumStyled>{store.group}</SubtitleMediumStyled>
            </AlignedValue>
          </Content>

          <Content>
            <AlignedValue>
              <SubtitleMediumBoldStyled>Loja</SubtitleMediumBoldStyled>
            </AlignedValue>

            <AlignedValue>
              <SubtitleMediumStyled>{store.store}</SubtitleMediumStyled>
            </AlignedValue>
          </Content>

          <Content>
            <AlignedValue>
              <SubtitleMediumBoldStyled>Nome</SubtitleMediumBoldStyled>
            </AlignedValue>
            <AlignedValue>
              <SubtitleMediumStyled>{store.sellerName}</SubtitleMediumStyled>
            </AlignedValue>
          </Content>

          <Content>
            <AlignedValue>
              <SubtitleMediumBoldStyled>Vendas</SubtitleMediumBoldStyled>
            </AlignedValue>

            <AlignedValue>
              <SubtitleMediumStyled>{store.sales}</SubtitleMediumStyled>
            </AlignedValue>
          </Content>
        </Container>
      ))}
    </BoxCustom>
  );
};
